<template>
  <v-app>
    <div class="card card-custom">
      <div class="card-body p-0">
        <div
            class="wizard wizard-2"
            id="kt_wizard_v2"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
        >
          <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">
            <!--begin: Wizard Form-->
            <div class="row">
              <div class="col-md-8 col-sm-12 col-lg-8 col-xs-12">
                <h4>
                  <router-link :to="{name:'user-list'}">
                    <i class="fas fa-arrow-left"></i>
                  </router-link>
                  Book Detail
                </h4>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="row">
                  <div class="col-2" v-if="user.image_path">
                    <img :src="user.image_path['real']" :alt="user.full_name" height="350px" width="100%">
                  </div>
                  <div class="col-5">
                    <table class="table mt-3">
                      <tr>
                        <th>Name</th>
                        <td class="">{{ user.full_name }}</td>
                      </tr>
                      <tr>
                        <th>Email</th>
                        <td class="">{{ user.email }}</td>
                      </tr>
                      <tr>
                        <th>Phone</th>
                        <td class="">{{ user.phone }}</td>
                      </tr>
<!--                      <pre>{{user}}</pre>-->
                      <tr>
                        <th>Type</th>
                        <td class="">
                          <div v-if="user.type && user.type.length>0">
                            <span class="badge badge-primary" v-for="(t, i) of user.type"
                                  :key="i">{{ t.toUpperCase() }}</span>
                          </div>
                        </td>

                      </tr>
                      <tr>
                        <th>Symbol No</th>
                        <td class="">{{ user.setting ? user.setting.symbol_no : '-' }}</td>
                      </tr>
                      <tr>
                        <th>Id Card No</th>
                        <td class="">{{ user.id_card_no ? user.id_card_no : '-' }}</td>
                      </tr>
                      <tr>
                        <th>Program</th>
                        <td class="">{{ user.setting ? user.setting.program_title : '-' }}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-5">
                    <table class="table mt-3">

                      <tr>
                        <th>Class</th>
                        <td class="">{{ user.setting ? user.setting.current_semester_title : '-' }}</td>
                      </tr>
                      <tr v-if="user.setting && user.setting.current_class_title">
                        <th>Section</th>
                        <td class="">{{ user.setting ? user.setting.current_class_title : '-' }}</td>
                      </tr>
                      <tr v-if="user.permanent_address && user.permanent_address.length>0">
                        <th>Permanent Address</th>
                        <td class="">{{ user.permanent_address[0].full_address }}</td>
                      </tr>
                      <tr v-if="user.temporary_address && user.temporary_address.length>0">
                        <th>Temporary Address</th>
                        <td class="">{{ user.temporary_address[0].full_address }}</td>
                      </tr>
                      <tr v-if="user.father && user.father.length>0">
                        <th>Father</th>
                        <td class="">{{ `${user.father[0].full_name} ${user.father[0].phone}` }}</td>
                      </tr>
                      <tr v-if="user.mother && user.mother.length>0">
                        <th>Mother</th>
                        <td class="">{{ `${user.mother[0].full_name} ${user.mother[0].phone}` }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <user-issued-list
                    v-if="currently_issued.length>0"
                    :type="'currently'"
                                  :issued_books="currently_issued"
                    @reload_issued_book="reloadIssuedBook()"
                    :action="true"
                    :user="user"
                    @refresh="getIssuedBook"
                ></user-issued-list>
<!--                <user-issued-book v-if="previously_issued.length>0" :type="'previously'"-->
<!--                                  :issued_books="previously_issued" :action="false"></user-issued-book>-->
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <pre>
</pre>
  </v-app>
</template>
<script>

import userService from "@/core/services/user/UserService";
import BookService from "@/core/services/library/book/BookService";
import IssueService from "@/core/services/library/issue/IssueService";
// import UserIssuedBook from "./UserIssuedList";
import SettingService from "@/core/services/library/setting/SettingService";

import UserIssuedList from "@/view/pages/library/return/UserIssuedList";


const setting = new SettingService();
const bookService = new BookService();
const userSer = new userService();
const issueService = new IssueService();

export default {
  name: "user-detail",
  components: {
    UserIssuedList
  },
  data() {
    return {
      isBusy: false,
      limit_reached: false,
      book_availability: {},
      user: {},
      setting: {},
      books: [],
      currently_issued: [],
      previously_issued: [],
      issue: {
        book_id: null,
        user_id: null
      }
    }
  }, computed: {
    user_id() {
      return this.$route.params.id
    },
  }, mounted() {
    if (this.user_id) {
      this.getUser();
      this.getBooks();
      this.getSetting()
    }
  }, methods: {
    getBooks() {
      bookService.getActive().then(response => {
        this.books = response.data
      })
    }, getSetting() {
      setting.first().then(response => {
        if (response.data)
          this.setting = response.data
      })
    },
    getIssuedBook(type) {
      issueService.issuedBook(this.user_id, type).then(response => {
        if (type == "currently") {
          this.currently_issued = response.data.books
          if (this.currently_issued.length == this.setting.max_book_allowed) {
            this.limit_reached = true
          }
        } else {
          this.previously_issued = response.data.books
        }
      })
    },
    getUser() {
      userSer.show(this.user_id).then(response => {
        this.user = response.data.user
        this.getIssuedBook('currently');
        this.getIssuedBook('previously');
      })
    }, redirectTo() {
      this.$router.push({name: "user-list"})
    }, issueBook() {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            this.issue.user_id = this.user_id;
            issueService.store(this.issue).then(response => {
              this.getIssuedBook('currently');
              this.getIssuedBook('previously');
            })
          }
        }
      })
    }, checkBookAvailability() {
      issueService.checkBookAvailability(this.user_id, this.issue.book_id).then(response => {
        this.book_availability = response.data.availability
      })
    }, reloadIssuedBook(data){
      this.getIssuedBook('currently');
      this.getIssuedBook('previously');
    }
  }
}
</script>

<style scoped>

</style>